import { render, staticRenderFns } from "./FaqRefonte.vue?vue&type=template&id=e5f51a02&scoped=true&"
import script from "./FaqRefonte.vue?vue&type=script&lang=js&"
export * from "./FaqRefonte.vue?vue&type=script&lang=js&"
import style0 from "./FaqRefonte.vue?vue&type=style&index=0&id=e5f51a02&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f51a02",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Faq: require('/app/components/Faq.vue').default})
